export default "__VITE_ASSET__B505$9rV__"